<div class="bh-loader h-100">
    <div class="bh-loader-position-center d-flex align-items-center">
        <!-- <img class="loader-text me-1" src="assets/icon/loading.svg" alt="loading text" /> -->
        <div class="txt-container d-flex">
            <ion-text color="primary" class="text-uppercase weight-600">L</ion-text>
            <ion-text color="primary" class="text-lowercase weight-600">O</ion-text>
            <ion-text color="primary" class="text-lowercase weight-600">A</ion-text>
            <ion-text color="primary" class="text-lowercase weight-600">D</ion-text>
            <ion-text color="secondary" class="text-lowercase weight-600">I</ion-text>
            <ion-text color="secondary" class="text-lowercase weight-600">N</ion-text>
            <ion-text color="secondary" class="text-lowercase weight-600">G</ion-text>
        </div>
        <div style="min-width: 5rem" class="d-flex justify-content-evenly">
            <div style="min-width: 13px" class="d-flex align-items-end justify-content-center">
                <div class="square one"></div>
            </div>
            <div style="min-width: 13px" class="d-flex align-items-end justify-content-center">
                <div class="square two"></div>
            </div>
            <div style="min-width: 13px" class="d-flex align-items-end justify-content-center">
                <div class="square three"></div>
            </div>
        </div>
    </div>
</div>
